import gql from 'graphql-tag'
import { get } from 'lodash'

import { PartialGroup } from '../types/IGroup'
import { apolloClientPrivate } from '../../../graphql/apolloClient'

export interface IVariables {
  userId: number
  groupId: number
}

export interface IResponse {
  user: {
    removeFromGroup: {
      groups: PartialGroup[]
    }
  }
}

export type IOperationResult = PartialGroup[]

export const REMOVE_FROM_GROUP_MUTATION = gql`
  mutation removeUserFromGroup($userId: PositiveInt!, $groupId: PositiveInt!) {
    admin {
      user(id: $userId) {
        id
        removeFromGroup(groupId: $groupId) {
          groups {
            id
            name
          }
        }
      }
    }
  }
`

export default async (variables: IVariables): Promise<IOperationResult> => {
  const response = await apolloClientPrivate.mutate<IResponse>({
    variables,
    mutation: REMOVE_FROM_GROUP_MUTATION
  })

  return get(response, 'data.admin.user.removeFromGroup.groups')
}
